import { createContext, useState } from "react";

const FormDataContext = createContext({});

export const FormDataProvider = ({ children }) => {
  const [formData, setFormData] = useState({});
  const [showProcessingScreen, setShowProcessingScreen] = useState(false);

  return (
    <FormDataContext.Provider value={{ formData, setFormData, showProcessingScreen, setShowProcessingScreen }}>
      {children}
    </FormDataContext.Provider>
  );
};

export default FormDataContext;